import request from '@/utils/request'

export function goodsDiscountList (query) {
  return request({
    url: '/shop/discount/',
    method: 'get',
    params: query
  })
}
export function createGoodsDiscount (parameter) {
  return request({
    url: '/shop/discount/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
export function goodsDiscountImport (parameter) {
  return request({
    url: '/shop/goods/discount_download_excel/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
export function downloadGoodsDiscountExcel () {
  return request({
    url: '/shop/goods/discount_download_excel/',
    method: 'get',
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    responseType: 'blob'
  })
}
export function putGoodsDiscount (parameter, id) {
  return request({
    url: '/shop/discount/' + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
export function deleteGoodsDiscount (id) {
  return request({
    url: '/shop/discount/' + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
